export default [
  {
    path: '/ci/sended',
    name: 'ci_sended',
    component: () => import('./SendedCi.vue'),
    meta: {
      pageSection: 'Comunicação interna',
      pageTitle: 'CI - Enviadas',
      auth: true,
      user: 'Admin',
    },
  },
]
